$.lui("layout","#layout_header", function(selector) {
    let header = selector.find(".wrp_header_body");

    $.importScript(cdnjs.headroom, function(){
        let headroom = new Headroom(selector[0], {
            offset: 5,
            tolerance : {
                up : 5,
                down : 0
            },
            classes: {
                "initial" : "headroom",
                "pinned": "headroom--pinned",
                "unpinned": "headroom--unpinned",
                "top" : "headroom--top",
                "notTop" : "headroom--not-top"
            }
        });
        headroom.init();
    });

    let refs = {
        submenus: selector.find(`[data-ref="submenu"]`)
    };

    (function() {
        let timer_out;
        let nav_items = selector.find(".elm_header_nav .elm_nav_item");
        let triggers = selector.find(`[data-hover="submenu"]`);
        let focusable_selector = `a, button, input, select, textarea, [tabindex]`;
        let ignore_focus_el;

        triggers.attr({
            "aria-haspopup": "true",
            "aria-expanded": "false"
        });
        refs.submenus.attr("aria-hidden", "true");

        selector.off(".headerSubmenu");
        refs.submenus.off(".headerSubmenu");

        function getSubmenu(elm) {
            return $(refs.submenus.filter(`[data-sub="${elm.data("sub")}"]`));
        }

        function getTrigger(submenu) {
            return $(triggers.filter(`[data-sub="${submenu.data("sub")}"]`));
        }

        function containsFocus(elm, submenu, target) {
            return target && (
                elm[0] === target ||
                submenu[0] === target ||
                $.contains(elm[0], target) ||
                $.contains(submenu[0], target)
            );
        }

        function setSubmenuFocus(submenu, is_enabled) {
            submenu.find(focusable_selector).each(function() {
                let item = $(this);

                if(!is_enabled) {
                    if(typeof item.data("submenu-tabindex") === "undefined") {
                        item.data("submenu-tabindex", item.attr("tabindex") || "");
                    }
                    item.attr("tabindex", "-1");
                    return;
                }

                if(typeof item.data("submenu-tabindex") === "undefined") {
                    return;
                }

                if(item.data("submenu-tabindex") === "") {
                    item.removeAttr("tabindex");
                } else {
                    item.attr("tabindex", item.data("submenu-tabindex"));
                }
            });
        }

        function getFocusableItems(submenu) {
            return submenu.find(focusable_selector).filter(function() {
                return $(this).attr("tabindex") !== "-1";
            });
        }

        function getNavItem(elm, offset) {
            let index = nav_items.index(elm);

            if(index === -1) {
                return $();
            }

            return nav_items.eq(index + offset);
        }

        function hideSubmenu(elm, submenu) {
            if(!submenu.hasClass("state--active")) {
                elm.removeClass("state--hover").attr("aria-expanded", "false");
                submenu.removeClass("state--hiding").attr("aria-hidden", "true");
                setSubmenuFocus(submenu, false);
                return;
            }

            submenu.addClass("state--hiding").attr("aria-hidden", "true");
            setSubmenuFocus(submenu, false);
            setTimeout(function() {
                submenu.removeClass("state--active state--hiding");
                elm.removeClass("state--hover").attr("aria-expanded", "false");
            },300);
        }

        function resetSubmenus() {
            clearTimeout(timer_out);
            triggers.removeClass("state--hover").attr("aria-expanded", "false");
            refs.submenus.removeClass("state--active state--hiding").attr("aria-hidden", "true").each(function() {
                setSubmenuFocus($(this), false);
            });
        }

        function scheduleHide(elm, submenu) {
            clearTimeout(timer_out);
            timer_out = setTimeout(function() {
                hideSubmenu(elm, submenu);
            },500);
        }

        function showSubmenu(elm, submenu) {
            clearTimeout(timer_out);
            submenu.removeClass("state--hiding").addClass("state--active").attr("aria-hidden", "false");
            setSubmenuFocus(submenu, true);
            elm.addClass("state--hover").attr("aria-expanded", "true");
            triggers.not(elm).removeClass("state--hover").attr("aria-expanded", "false");

            $(refs.submenus.not(submenu)).each(function () {
                let other = $(this);
                if(other.hasClass("state--active")) {
                    hideSubmenu(getTrigger(other), other);
                }
            });
        }

        refs.submenus.each(function() {
            setSubmenuFocus($(this), false);
        });

        selector.on("mouseenter.headerSubmenu focusin.headerSubmenu", `[data-hover="submenu"]`, function (e) {
            if(e.type === "focusin" && ignore_focus_el === this) {
                ignore_focus_el = undefined;
                return;
            }

            let elm = $(this);
            showSubmenu(elm, getSubmenu(elm));
        });

        selector.on("mouseleave.headerSubmenu focusout.headerSubmenu", `[data-hover="submenu"]`, function (e) {
            let elm = $(this);
            let submenu = getSubmenu(elm);

            if(e.type === "focusout" && containsFocus(elm, submenu, e.relatedTarget)) {
                return;
            }

            scheduleHide(elm, submenu);
        });

        selector.on("keydown.headerSubmenu", `[data-hover="submenu"]`, function (e) {
            let elm = $(this);
            let submenu = getSubmenu(elm);

            if(e.key === "Tab" && !e.shiftKey && submenu.hasClass("state--active")) {
                let focusable_items = getFocusableItems(submenu);

                if(focusable_items.length) {
                    e.preventDefault();
                    focusable_items.first().trigger("focus");
                }
                return;
            }

            if(e.key === "ArrowDown" && submenu.hasClass("state--active")) {
                let focusable_items = getFocusableItems(submenu);

                if(focusable_items.length) {
                    e.preventDefault();
                    focusable_items.first().trigger("focus");
                }
                return;
            }

            if(e.key !== "Escape") {
                return;
            }

            hideSubmenu(elm, submenu);
        });

        refs.submenus.on("mouseenter.headerSubmenu focusin.headerSubmenu", function() {
            clearTimeout(timer_out);
        });

        refs.submenus.on("mouseleave.headerSubmenu focusout.headerSubmenu", function(e) {
            let submenu = $(this);
            let elm = getTrigger(submenu);

            if(e.type === "focusout" && containsFocus(elm, submenu, e.relatedTarget)) {
                return;
            }

            scheduleHide(elm, submenu);
        });

        refs.submenus.on("keydown.headerSubmenu", function(e) {
            let submenu = $(this);
            let elm = getTrigger(submenu);

            if(e.key === "Tab") {
                let focusable_items = getFocusableItems(submenu);
                let first_item = focusable_items.first()[0];
                let last_item = focusable_items.last()[0];

                if(e.shiftKey && e.target === first_item) {
                    e.preventDefault();
                    hideSubmenu(elm, submenu);
                    ignore_focus_el = elm[0];
                    elm.trigger("focus");
                    return;
                }

                if(!e.shiftKey && e.target === last_item) {
                    let next_item = getNavItem(elm, 1);

                    if(!next_item.length) {
                        return;
                    }

                    e.preventDefault();
                    hideSubmenu(elm, submenu);
                    next_item.trigger("focus");
                    return;
                }
            }

            if(e.key !== "Escape") {
                return;
            }

            hideSubmenu(elm, submenu);
            ignore_focus_el = elm[0];
            elm.trigger("focus");
        });

        selector.on("click.headerSubmenu", "a", function() {
            resetSubmenus();
        });
    })();
});

$.importScript(cdnjs.touchswipe, function() {
    $('.ssm-nav').lui_ssm();
});
